//#region src/compat/_internal/MAX_SAFE_INTEGER.ts
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
//#endregion
export { MAX_SAFE_INTEGER };
